export function handleChangeForm({ stateName, prop, state, emit }) {
  const newValues = {
    ...prop,
    [stateName]: state[stateName],
  };

  emit(`update:${prop.constructor.name}`, newValues);
}

export function handleChangeToggle({ newValue, prop, deactivatedFieldsForClearing, activatedFieldsForClearing, toggledValueName, state, emit }) {
  if (!newValue && deactivatedFieldsForClearing) {
    deactivatedFieldsForClearing.forEach(valueName => {
      state[valueName] = '';
      emit(`update:${prop.constructor.name}`, { ...prop, [valueName]: '' });
    });
  }

  if (newValue && activatedFieldsForClearing) {
    activatedFieldsForClearing.forEach(valueName => {
      state[valueName] = '';
      emit(`update:${prop.constructor.name}`, { ...prop, [valueName]: '' });
    });
  }

  emit(`update:${prop.constructor.name}`, { ...prop, [toggledValueName]: newValue });
}

export function limitInput( word ) {
  return word.replace(/[^а-яА-ЯёЁ]/ig,'')
}